import React from 'react';
import styled from 'styled-components';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ProjectsContext from './ProjectsContext';
import ProjectWorkflowForm from './ProjectWorkflowForm';
import ProceduresMain from '../procedures/ProceduresMain';


const Container = styled.div`
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:space-between;
    justify-content:space-between;
    padding-top:10px;
    padding-bottom:40px;
    padding-left:20px;
`;

const ContainerHeader = styled.div`
    width:100%;
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    text-align: left;
    padding-left:0px;
    padding-top:20px;

`;

const ContainerSubHeader = styled.div`
    width:100%;
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0.25px;
    text-align: left;
    padding-left:0px;
    padding-bottom:10px;

`;

const ContainerSteps = styled.div`
width:95%;
`;

const TabsWrapper = styled.div`
    width:95%;
    padding-top:10px;
`;

const TabPanels = styled.div`
    width:95%;
`;

const ProceduresSection = styled.div`
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:flex-start;
`;

const ProceduresTabsWrapper = styled.div`
    padding-top:16px;
    width:100%;
`;

const ProceduresContent = styled.div`
    padding-top:10px;
    width:100%;
`;

const ProceduresTabValues = {
    Enterprise: 'Enterprise',
    ProjectSpecific: 'Project-Specific',
};


class ProjectWorkflowContainer extends React.Component {

    static contextType = ProjectsContext;

    handleTabChange = (event, newValue) => {
        this.context.setProjectWorkflowActiveTab(newValue);
    };

    handleProceduresTabChange = (event, newValue) => {
        this.context.setProjectWorkflowProceduresTab(newValue);
    };

    getHasMissingPrimary() {
        const { selectedFunction } = this.context.reduxStore;
        const { functionsMissingPrimary = {} } = this.context;
        if (!selectedFunction || !selectedFunction.id) {
            return false;
        }
        return Boolean(functionsMissingPrimary[selectedFunction.id]);
    }

    isProceduresTabDisabled() {
        const hasMissingPrimary = this.getHasMissingPrimary();
        const hasPendingWorkflowChanges = Boolean(this.context.workflowHasPendingChanges);
        return hasMissingPrimary || hasPendingWorkflowChanges;
    }

    componentDidUpdate() {
        const shouldDisableProcedures = this.isProceduresTabDisabled();
        const { projectWorkflowActiveTab } = this.context;

        if (shouldDisableProcedures && projectWorkflowActiveTab !== 0) {
            this.context.setProjectWorkflowActiveTab(0);
            return;
        }
    }


    render()
    {
        const {selectedProjectOrGbu,selectedFunctionDetails,selectedFunction} = this.context.reduxStore;
        const { projectWorkflowActiveTab: activeTab, projectWorkflowProceduresTab: proceduresTab } = this.context;

        if(!selectedFunction) return null;
        const hasMissingPrimary = this.getHasMissingPrimary();
        const hasPendingWorkflowChanges = Boolean(this.context.workflowHasPendingChanges);
        const proceduresTabDisabled = this.isProceduresTabDisabled();
        return (
                <Container>
                    <ContainerHeader>{`${selectedProjectOrGbu.name}`}</ContainerHeader>
                    <ContainerSubHeader>{`${selectedFunction.name} `}</ContainerSubHeader>
                    <TabsWrapper>
                        <Tabs
                            value={activeTab}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={this.handleTabChange}
                        >
                            <Tab label="Workflow" />
                            <Tab label="Procedures" disabled={proceduresTabDisabled} />
                        </Tabs>
                    </TabsWrapper>
                    <TabPanels>
                        {activeTab === 0 && selectedFunctionDetails && (
                            <ContainerSteps>
                                <ProjectWorkflowForm
                                    workflowSteps={selectedFunctionDetails.workflowSteps}
                                    isGbu={selectedProjectOrGbu.isGbu}
                                    context={this.context}
                                    initialValues={selectedFunctionDetails}
                                />
                            </ContainerSteps>
                        )}
                        {activeTab === 1 && (
                            <ProceduresSection>
                                <ProceduresTabsWrapper>
                                    <Tabs
                                        value={proceduresTab}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        onChange={this.handleProceduresTabChange}
                                    >
                                        <Tab label="Enterprise" value={ProceduresTabValues.Enterprise} />
                                        <Tab label="Project Specific" value={ProceduresTabValues.ProjectSpecific} />
                                    </Tabs>
                                </ProceduresTabsWrapper>
                                <ProceduresContent>
                                    {proceduresTab === ProceduresTabValues.ProjectSpecific ? (
                                        <ProceduresMain isProjectSpecific />
                                    ) : (
                                        <ProceduresMain isProjectSpecificCorporate />
                                    )}
                                </ProceduresContent>
                            </ProceduresSection>
                        )}
                    </TabPanels>
                </Container>
        )
    }

}

export default ProjectWorkflowContainer;